import { DisableInfoView } from '../../dashboard/pages/DisableInfoView';

export const PUBLIC_ROUTES = [{ path: '/user-info/:id', element: <DisableInfoView /> }];
